import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

const prepaidInventoryStyle = {
	...sweetAlertStyle
};

export default prepaidInventoryStyle;
